import { render, staticRenderFns } from "./ProgressOverviewComp.vue?vue&type=template&id=325915f5&scoped=true&"
import script from "./ProgressOverviewComp.vue?vue&type=script&lang=ts&"
export * from "./ProgressOverviewComp.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressOverviewComp.vue?vue&type=style&index=0&id=325915f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325915f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsSlider})
